export class KafkaTopicsProbeResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "topics",
            "baseName": "topics",
            "type": "Array<KafkaTopicInfo>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KafkaTopicsProbeResponse.attributeTypeMap;
    }
    constructor() {
    }
}
